<template>
  <div id="app">
    <router-view/>

  </div>
</template>

<script>

  export default {
    name: 'App',
  }
</script>

<style>


@import "./styles/index.scss";
@import "./styles/element-ui.scss";
@import "./styles/iconfont.css";

.el-drawer__body {
   overflow: auto  !important;
}


.el-drawer ::-webkit-scrollbar {
  display: none;
}


/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar{
    width: 6px;
    height: 6px;
    background-color: #f5f5f5;
}
/*定义滚动条的轨道，内阴影及圆角*/
::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}
/*定义滑块，内阴影及圆角*/
::-webkit-scrollbar-thumb{
    height: 10px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;
}

@media screen  and (max-width: 768px) {
  .el-drawer{
      width: auto !important ;
      max-width: 90% !important;
  }
  .el-message-box{
    width: 80%;
  }
  .el-form{
    margin-top: 40px;
  }
}
.app-main{
  min-height: calc(100vh  - 40px);
  background-color: #EFF0F2;
  padding:  30px;
  padding-bottom:  50px;

  position: relative;
   background-image: url(./assets/images/askldhjak.png);
  background-size: 100vw 100vh;
  background-repeat: repeat;
}
/* .app-main::after{
  display: inline-block;
  content:  ' ' !important;
  width: 100% !important;
  height: 100% !important;
  position: absolute;
 
  top: 0;
  left: 0;
  z-index: -1;
} */
/* .main-container{
  padding: 30px;

  background-color: #EFF0F2;
} */

 .app-container{
  min-height: calc(100%);
  box-sizing: border-box;
  border-radius: 8px;
  /* background-color: white !important; */
}



.opageInfo{
  border-radius: 6px;
  box-shadow: 0px 0px 6px 0px rgba(5, 5, 5, 0.12);
  margin-top: 20px;
  padding: 20px;
  background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/App.vue